<template>
  <div class="history">
    <div class="section">
      <div class="container">
        <h1 class="title is-spaced">History</h1>
        <h2
          class="subtitle"
        >Missed a marathon or want to see what we've done in the past? Check out past marathons below</h2>
      </div>
    </div>
    <div class="history-table">
      <div class="container">
        <table class="table">
          <thead>
            <tr>
              <th>Marathon</th>
              <th>Charity</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th class="right">Duration</th>
              <th class="right">Attendees</th>
              <th class="right">Donation Total</th>
              <th>Playlist</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(marathon, index) in history" :key="`marathon.${index}`">
              <td>{{ marathon.name }}</td>
              <td>{{ marathon.charity }}</td>
              <td>{{ marathon.start_date | localDate }}</td>
              <td>{{ marathon.end_date | localDate }}</td>
              <td class="right">{{ marathon.duration | durationToHours }}</td>
              <td class="right">{{ marathon.attendees }}</td>
              <td
                class="right"
              >${{ marathon.donation_total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
              <td>
                <a :href="marathon.playlist" target="_blank">Watch</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "history",
  data() {
    return {
      history: [],
    };
  },

  mounted() {
    this.http.get("/static/data/history.json").then((response) => {
      if (response.status !== 200) return;

      var data = response.data;
      this.history = data.history;
    });
  },

  filters: {
    localDate(date) {
      return moment(date).local().format("Do MMM YYYY, hh:mma");
    },

    durationToHours(minutes) {
      return minutes / 60 + " hours";
    },
  },
};
</script>

<style scoped lang="scss">
$table-background-color: rgba(255, 255, 255, 0.75);
$table-cell-border: 1px solid darken($default-border-col, 15%);

@media screen and (max-width: $phone-size) {
  $table-row-hover-background-color: transparent;
  $table-row-active-background-color: transparent;
}

@import "~bulma/sass/layout/section";
@import "~bulma/sass/elements/table";

.section {
  @media screen and (max-width: $phone-size) {
    padding: 1.5em;
  }
}

.history-table {
  .container {
    display: flex;
    justify-content: center;

    @media screen and (max-width: $phone-size) {
      display: inline-block;
      padding: 15px;
      overflow-x: auto;
      width: 100%;
    }
  }

  .table {
    width: 100%;

    .right {
      text-align: right;
    }
  }

  .table td {
    vertical-align: middle;

    span {
      clear: none;
      float: left;
      display: inline-block;
      width: auto;

      &:not(.fa) {
        width: calc(100% - 30px);
      }
    }

    &.no-padding {
      padding: 0;
    }
  }

  .fa {
    margin-right: 10px;
  }

  @media screen and (max-width: $phone-size) {
    width: 100%;

    .table {
      overflow-x: auto;
      width: 100%;
    }
  }

  @media screen and (max-width: $phone-size) {
    .table thead {
      display: none;
    }

    .table tr {
      border-bottom: $table-cell-border;
    }

    .table td {
      border: 0;
      clear: both;
      float: left;
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?4e161e77